import { render } from "./PeopleHolder.vue?vue&type=template&id=11143527&scoped=true"
import script from "./PeopleHolder.vue?vue&type=script&lang=js"
export * from "./PeopleHolder.vue?vue&type=script&lang=js"

import "./PeopleHolder.vue?vue&type=style&index=0&id=11143527&lang=css"
import "./PeopleHolder.vue?vue&type=style&index=1&id=11143527&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11143527"]])

export default __exports__